import React from "react";
import AWSConnectionDrawer from "./AWSConnectionDrawer";
import AzureConnectionDrawer from "./AzureConnectionDrawer";
import GCPConnectionDrawer from "./GCPConnectionDrawer";
import DirectApiConnectionDrawer from "./DirectApi/DirectApiConnectionDrawer";
import { DIRECT_API_SPECS } from "./DirectApi/directApiSpecs";
import TrutoIntegrationConnectionDrawer from "./TrutoIntegrationConnectionDrawer";
import WatchTowerConnectionDrawer from "./WatchTowerConnectionDrawer";
import GitHubConnectionDrawer from "./GitHubConnectionDrawer";
import { MasterLookupItemsType } from "../../../../utils/enums";
/**
 * Router component that renders the appropriate integration drawer
 * based on the integrationKey prop
 */
const IntegrationConnectionDrawer = ({
  open,
  onClose,
  integrationKey,
  integrationLabel,
  integrationLogo,
  domainKey,
  refetchIntegrationDetails,
  onStoreIntegrationDetails,
  onShowSnackbar,
  reconnectRciId,
  onReconnect,
  reconnectBaseUrl,
}) => {
  const showError = (message) => {
    if (onShowSnackbar) {
      onShowSnackbar({
        message,
        vertical: "top",
        horizontal: "right",
      });
    }
  };

  const isIdpIntegration = domainKey === MasterLookupItemsType.IDP_PROVIDER;

  if (isIdpIntegration) {
    const idpConfig = {
      heading: `Connect ${integrationLabel}`,
      subtitle: `Follow the steps below to establish a secure connection with ${integrationLabel}`,
      steps: [],
      alert: {
        severity: "info",
        title: "Important: Admin or Delegate Admin Account Required",
        message: `To connect this integration, you'll need to sign in with an admin or delegate admin account from ${integrationLabel}. This ensures we can properly sync user data and manage access.`,
      },
      beforeConnecting: [
        `Sign in with an admin account from your ${integrationLabel} organization`,
        "Grant necessary permissions for user directory access",
        "Authorize the connection to sync user data",
      ],
    };

    return (
      <TrutoIntegrationConnectionDrawer
        open={open}
        onClose={onClose}
        integrationKey={integrationKey}
        integrationLabel={integrationLabel}
        integrationLogo={integrationLogo}
        refetchIntegrationDetails={refetchIntegrationDetails}
        config={idpConfig}
        onError={showError}
      />
    );
  }

  switch (integrationKey) {
    case "github":
      return (
        <GitHubConnectionDrawer
          open={open}
          onClose={onClose}
          integrationLabel={integrationLabel}
          integrationLogo={integrationLogo}
          refetchIntegrationDetails={refetchIntegrationDetails}
          onError={showError}
        />
      );
    case "rego_watch_tower":
      return (
        <WatchTowerConnectionDrawer
          open={open}
          onClose={onClose}
          integrationLabel={integrationLabel}
          refetchIntegrationDetails={refetchIntegrationDetails}
        />
      );
    case "aws":
      return (
        <AWSConnectionDrawer
          open={open}
          onClose={onClose}
          refetchIntegrationDetails={refetchIntegrationDetails}
          onStoreIntegrationDetails={onStoreIntegrationDetails}
        />
      );
    case "azure":
      return (
        <AzureConnectionDrawer
          open={open}
          onClose={onClose}
          refetchIntegrationDetails={refetchIntegrationDetails}
          onStoreIntegrationDetails={onStoreIntegrationDetails}
        />
      );
    case "gcp":
      return (
        <GCPConnectionDrawer
          open={open}
          onClose={onClose}
          refetchIntegrationDetails={refetchIntegrationDetails}
          onStoreIntegrationDetails={onStoreIntegrationDetails}
        />
      );
    default:
      // Direct-API vendors (Horilla today, future ones added by dropping a
      // spec into directApiSpecs.js). The generic drawer renders the spec's
      // fields and submits a JSON-encoded payload — no new component per
      // vendor. If a vendor needs truly bespoke UX, add a case above this
      // default instead.
      if (DIRECT_API_SPECS[integrationKey]) {
        return (
          <DirectApiConnectionDrawer
            open={open}
            onClose={onClose}
            spec={DIRECT_API_SPECS[integrationKey]}
            integrationKey={integrationKey}
            onStoreIntegrationDetails={onStoreIntegrationDetails}
            onReconnect={onReconnect}
            reconnectRciId={reconnectRciId}
            reconnectBaseUrl={reconnectBaseUrl}
          />
        );
      }
      return null;
  }
};

export default IntegrationConnectionDrawer;
